// if (window.innerWidth < 768) {
//   const searchInput = document.querySelector(
//     ".main-search__form #wizzy-search-input-mobile"
//   );

//   if (searchInput) {
//     searchInput.addEventListener("click", function () {
//       setTimeout(function () {
//         wizzySearchPopup.click();
//         wizzySearchPopup.focus();
//       }, 100);
//     });
//   }
// }

// Clean up the observer (optional, when no longer needed)
// observer.disconnect();
window.innerWidth > 768 &&
  window.addEventListener("scroll", function () {
    var autoCompleteWrapper = document.querySelector(
      ".wizzy-autocomplete-wrapper"
    );
    if (autoCompleteWrapper) {
      var searchBar = document.querySelector(
        ".st-search-autocomplete #st-search-input-mobile"
      );
      if (searchBar) {
        var positionInfo = searchBar.getBoundingClientRect(),
          left = positionInfo.left,
          top = positionInfo.top + positionInfo.height;
        autoCompleteWrapper.style.setProperty("top", top + "px", "important");
      }
    }
  });
function checkWizzyConfigAndUpdate() {
  window.wizzyConfig.common.isOnCategoryPage == true
    ? (window.wizzyConfig.common.lazyDOMConfig.contentDOMIdentifiers = [
        "#wizzy-shopify-collection-page-wrapper",
      ])
    : (window.wizzyConfig.common.lazyDOMConfig.contentDOMIdentifiers = [
        "#main",
      ]),
    // window.wizzyConfig.common.lazyDOMConfig.contentDOMIdentifiers.push("#main");

    window.matchMedia("(max-width: 768px)").matches
      ? (window.wizzyConfig.common.lazyDOMConfig.searchInputIdentifiers[0] = {
          dom: ".wizzy-search-form-wrapper .wizzy-search-form #searchInput",
          type: "text",
        })
      : (window.wizzyConfig.common.lazyDOMConfig.searchInputIdentifiers[0] = {
          dom: ".header-search__form-control .header-search__input",
          type: "search",
        }),
    clearInterval(interval);
}
var interval = setInterval(checkWizzyConfigAndUpdate, 100);

//code to get wizzy body asset data
let timeCheckedTemplates = 0;
const checkAndMoveDiv = setInterval(() => {
  timeCheckedTemplates++;

  if (moveTemplatesToBody()) {
    clearInterval(checkAndMoveDiv);
  }

  if (timeCheckedTemplates === 10) {
    clearInterval(checkAndMoveDiv);
  }
}, 10);

if (window.innerWidth < 768) {
  var searchIcons = document.querySelectorAll(
    ".header__secondary-nav .icon-search"
  );

  if (searchIcons.length > 0) {
    searchIcons.forEach((searchIcon) => {
      searchIcon.addEventListener("click", function () {
        // var searchInput = document.querySelector(".header-search__input");
        const searchInput = document.querySelector(
          ".wizzy-search-form-wrapper .wizzy-search-form #searchInput"
        );
        if (searchInput) {
          setTimeout(function () {
            searchInput.click();
            searchInput.focus();
          }, 300);
        }
      });
    });
  }
} else {
  var searchIcons = document.querySelectorAll(
    ".header__secondary-nav .icon-search"
  );

  if (searchIcons.length > 0) {
    searchIcons.forEach((searchIcon) => {
      searchIcon.addEventListener("click", function () {
        var searchInput = document.querySelector(".header-search__input");
        if (searchInput) {
          setTimeout(function () {
            searchInput.click();
            searchInput.focus();
          }, 300);
        }
      });
    });
  }
}
// window.innerWidth > 768 &&
//   document.body.addEventListener("click", function (event) {
//     if (
//       event.target.matches(".wizzy-facet-head") ||
//       event.target.matches(".facet-head-title")
//     ) {
//       const closestBlock = event.target.closest(
//           ".wizzy-filters-facet-block.facet-block-top"
//         ),
//         filterBox = document.querySelector(".wizzy-search-filters-list-top");
//       if (closestBlock) {
//         let left = closestBlock.getBoundingClientRect().left;
//         document
//           .querySelectorAll(
//             ".filters-list-top-values-wrapper .wizzy-facet-list"
//           )
//           .forEach(function (element) {
//             element.style.left = left + "px";
//           });
//       }
//     }
//   });
// if (window.innerWidth > 768) {
//   document.body.addEventListener("click", function (event) {
//     if (
//       event.target.matches(".wizzy-facet-head") ||
//       event.target.matches(".facet-head-title")
//     ) {
//       const closestBlock = event.target.closest(
//         ".wizzy-filters-facet-block.facet-block-top"
//       );

//       if (closestBlock) {
//         let left = closestBlock.getBoundingClientRect().left;
//         let top = closestBlock.offsetTop;

//         console.log(left);

//         document
//           .querySelectorAll(".wizzy-facet-list")
//           .forEach(function (element) {
//             element.style.left = left + "px";
//             // element.style.top = top - height + "px";
//           });
//       }
//     }
//   });
// }
window.onWizzyScriptLoaded = function () {
  // Replacing default template
  replaceTemplate("wizzy-search-results-product");
  replaceTemplate("wizzy-autocomplete-topproducts");
  replaceTemplate("wizzy-search-wrapper");

  window.wizzyConfig.events.registerEvent(
    window.wizzyConfig.events.allowedEvents.BEFORE_LAZY_INIT,
    function (payload) {
      window.wizzyConfig.common.isOnCategoryPage == !0
        ? (payload.common.lazyDOMConfig.contentDOMIdentifiers = [
            "#wizzy-shopify-collection-page-wrapper",
          ])
        : (payload.common.lazyDOMConfig.contentDOMIdentifiers = ["#main"]);

      return payload;
    }
  );
  window.wizzyConfig.events.registerEvent(
    window.wizzyConfig.events.allowedEvents.BEFORE_INIT,
    function (payload) {
      window.wizzyConfig.filters.configs.keepOpenedInMobileAfterApply = true;
      window.wizzyConfig.common.lazyDOMConfig.searchInputIdentifiers = [
        {
          dom: "#predictive-search-form .header-search__input.wizzy-search-input",
          type: "search",
        },
      ];
      window.wizzyConfig.common.isOnCategoryPage == !0
        ? (payload.common.lazyDOMConfig.contentDOMIdentifiers = [
            "#wizzy-shopify-collection-page-wrapper",
          ])
        : (payload.common.lazyDOMConfig.contentDOMIdentifiers = ["#main"]);

      return payload;
    }
  );

  window.wizzyConfig.events.registerEvent(
    window.wizzyConfig.events.allowedEvents.AFTER_PRODUCTS_TRANSFORMED,
    function (payload) {
      // console.log(payload, " <== AFTER_PRODUCTS_TRANSFORMED")
      payload.forEach((product) => {
          if(product.url && product.url !== "") {
            product.quickViewHandle = product.url.replace("https://www.louisstitch.com/products/","");
          }
      })
      return payload;
    }
  );

  window.wizzyConfig.events.registerEvent(
    window.wizzyConfig.events.allowedEvents.BEFORE_AUTOCOMPLETE_RENDER,
    function (data) {
      // console.log(data, "<====BEFORE_AUTOCOMPLETE_RENDER");
      // setTimeout(function () {
      //   const wizzyAutoCompleteWrapper = document.querySelector(
      //     ".wizzy-autocomplete-wrapper.onLeft"
      //   );

      //   if (wizzyAutoCompleteWrapper && window.innerWidth > 768) {
      //     wizzyAutoCompleteWrapper.addEventListener("click", () => {
      //       // const header = document.querySelector(
      //       //   ".header__nav-container header-search"
      //       // );
      //       // console.log(header);
      //       // // header.style.display =
      //       // setTimeout(function () {
      //       //   header.setAttribute("open", "");
      //       // }, 500);

      //       wizzyAutoCompleteWrapper.style.display = "none";
      //     });
      //   }
      // }, 1000);
      return data;
    }
  );

  window.wizzyConfig.events.registerEvent(
    window.wizzyConfig.events.allowedEvents.BEFORE_AUTOCOMPLETE_EXECUTED,
    function (payload) {
      // console.log(payload,"BEFORE_AUTOCOMPLETE_EXECUTED")
      return payload;
    }
  );

  window.wizzyConfig.events.registerEvent(
    window.wizzyConfig.events.allowedEvents.BEFORE_SEARCH_EXECUTED,
    function (payload) {
      // if (window.wizzyConfig.common.isOnProductViewPage) {
      //   window.wizzyConfig.common.lazyDOMConfig.contentDOMIdentifiers = [
      //     ".wizzy-search-main",
      //   ];
      // }

      payload.includeOutOfStock = "false";
      // if(payload.sort[0].field === 'relevance') {
      //   payload.sort = [{"field":"product_wizzy-best-selling_sortOrder:float","order":"asc"},{"field":"relevance","order":"asc"}]
      // }
       // SLP default sort: relevance first, then bestseller tiebreaker (matches Autocomplete priority).
      if (payload.sort?.[0]?.field === "relevance") {
        payload.sort = [
          { field: "relevance", order: "asc" },
          // {
          //   field: "product_wizzy-best-selling_sortOrder:float",
          //   order: "asc",
          // },
        ];
      }
       
      var body = document.body;
      if (body.classList.contains("product")) {
        body.classList.remove("product");
      } else if (body.classList.contains("index")) {
        body.classList.remove("index");
        body.classList.add("search");
      }

      if (window.innerWidth < 768) {
        const backBtn = document.querySelector(
          ".wizzy-search-form .wizzy-search-back"
        );
        if (backBtn) {
          backBtn.click();
        }
      } else {
        const closeBtn = document.querySelector(
          "#predictive-search-form .header-search__form-control button"
        );
        if (closeBtn) {
          closeBtn.click();
        }
      }

      const headerLogo = document.querySelector(
        "header height-observer x-header"
      );
      if (headerLogo) {
        if (!headerLogo.classList.contains("is-solid")) {
          headerLogo.classList.add("is-solid");
        }
      }
      return payload;
    }
  );

  window.wizzyConfig.events.registerEvent(
    window.wizzyConfig.events.allowedEvents.BEFORE_FILTERS_EXECUTED,
    function (payload) {
      payload.filters.inStock = ["true"];
      // console.log(payload.filters,"BEFORE_FILTERS_EXECUTED");
      return payload;
    }
  );

  window.wizzyConfig.events.registerEvent(
    window.wizzyConfig.events.allowedEvents.VIEW_RENDERED,
    function (data) {
      document
        .querySelector(".wizzy-common-select-selector")
        .addEventListener("click", function (params) {
          const filterBG = document.querySelector(
            ".wizzy-search-wrapper .wizzy-search-results-wrapper .wizzy-search-filters-left .wizzy-filters-bg"
          );
          filterBG.style.display = "none";

          if (window.innerWidth < 768) {
            const sortOptionHeading = document.querySelector(
              ".wizzy-common-select-options-heading-wrapper"
            );
            sortOptionHeading.style.display = "flex";
          }
        });

      window.innerWidth > 768 &&
        document.body.addEventListener("click", function (event) {
          if (
            event.target.matches(".wizzy-facet-head") ||
            event.target.matches(".facet-head-title")
          ) {
            const closestBlock = event.target.closest(
                ".wizzy-filters-facet-block.facet-block-top"
              ),
              filterBox = document.querySelector(
                ".wizzy-search-filters-list-top"
              );
            if (closestBlock) {
              let left = closestBlock.getBoundingClientRect().left;
              document
                .querySelectorAll(
                  ".filters-list-top-values-wrapper .wizzy-facet-list"
                )
                .forEach(function (element) {
                  element.style.left = left - 100 + "px";
                  element.style.top = "-15px";
                });
            }
          }
        });
      return data;
    },
    1
  );

  window.wizzyConfig.events.registerEvent(
    window.wizzyConfig.events.allowedEvents.BEFORE_RENDER_RESULTS,
    function (payload) {
      payload.response.payload.facets?.forEach((facet) => {
        if (facet.key === "sizes") {
          facet.data.sort((a, b) => parseInt(a.key, 10) - parseInt(b.key, 10));
        }
      });
      return payload;
    }
  );

  window.wizzyConfig.events.registerEvent(
    window.wizzyConfig.events.allowedEvents.PRODUCTS_RESULTS_RENDERED,
    function (payload) {
      return payload;
    }
  );
};

// Declaration of template replace function
const replaceTemplate = (div) => {
  let newDiv = document.getElementById(div + "-new").text;
  let oldDiv = document.getElementById(div);
  oldDiv.text = newDiv;
};


document.addEventListener('DOMContentLoaded', () => {

  // console.log("✅ DOMContentLoaded fired");

  const interval = setInterval(() => {

    // console.log("🔁 Checking for header-sidebar...");

    const host = document.querySelector('header-sidebar');

    if (!host) {
      // console.log("❌ header-sidebar NOT found yet");
      return;
    }

    // console.log("✅ header-sidebar found:", host);

    if (!host.shadowRoot) {
      // console.log("❌ shadowRoot NOT accessible (maybe closed or not ready)");
      return;
    }

    // console.log("✅ shadowRoot accessible");

    const shadow = host.shadowRoot;

    const searchInput = shadow.querySelector('.custom-search-input');

    if (!searchInput) {
      // console.log("❌ .custom-search-input NOT found inside shadowRoot");
      return;
    }

    // console.log("✅ Search input found:", searchInput);

    searchInput.addEventListener('click', function () {

      // console.log("🔥 Search input CLICKED");

      // 1️⃣ Close button inside shadow root
      const closeBtn = shadow.querySelector('button[is="dialog-close-button"]');

      if (!closeBtn) {
        // console.log("❌ Close button NOT found");
      } else {
        // console.log("✅ Close button found → Clicking");
        closeBtn.click();
      }

      // 2️⃣ Secondary nav search icon (normal DOM)
      const searchIcon = document.querySelector('.header__secondary-nav .icon-search');

      if (!searchIcon) {
        // console.log("❌ Secondary nav search icon NOT found");
      } else {
        // console.log("✅ Secondary nav search icon found → Dispatching click event");

        searchIcon.dispatchEvent(
          new MouseEvent('click', {
            bubbles: true,
            cancelable: true,
            view: window
          })
        );
      }

    });

    // console.log("🎯 Event listener attached successfully");
    clearInterval(interval);

  }, 400);

}); 